import http from '@/http/axios_init'

// 获取所有部门列表
export function getDeptList(data) {
	return http({
		method: 'post',
		url: 'customer/getDeptList',
		data
	})
}

// 根据部门id获取所有的员工
export function getEmpByDeptId(data) {
	return http({
		method: 'post',
		url: 'customer/getEmpByDeptId',
		data
	})
}

//获取用户信息
export function getUserInfo(data) {
	return http({
		method: 'post',
		url: 'admin/v1/public/emp/info',
		data
	})
}

//修改用户信息
export function editUserInfo(data) {
	return http({
		method: 'post',
		url: 'admin/v1/public/emp/edit',
		data
	})
}

//其他信息列表
export function getMessage(data) {
	return http({
		method: 'post',
		url: 'message',
		data
	})
}

//获取老师信息
export function get_emps(data) {
	return http({
		method: 'post',
		url: 'admin/v1/public/emp/get_emps',
		data
	})
}

// 确认部门信息
export function confirmDepartmentInfo(data) {
	return http({
		method: 'post',
		url: 'admin/v1/public/emp/edit_sure',
		data
	})
}
